export const REFERRAL_CACHE_KEYS = {
  REFERRAL_EVENT: 'referralEvent',
  USER_METRICS: 'userMetrics',
  USER_STATUS: 'userStatus',
  EVENTS_LIST: 'eventsList',
  CODE_VERIFICATION: 'codeVerification',
};
